export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707c13f01d9e766cbe7652f3b614cd61968fd0b616&name=pushAdClickData!'